<template>
  <g>
    <g clip-path="url(#clip0_15_977)">
      <path
        d="M22 6.98024V16.0002C22 17.1002 21.1 18.0002 20 18.0002H6L2 22.0002V4.00024C2 2.90024 2.9 2.00024 4 2.00024H14.1C14.04 2.32024 14 2.66024 14 3.00024C14 5.76024 16.24 8.00024 19 8.00024C20.13 8.00024 21.16 7.61024 22 6.98024ZM16 3.00024C16 4.66024 17.34 6.00024 19 6.00024C20.66 6.00024 22 4.66024 22 3.00024C22 1.34024 20.66 0.000244141 19 0.000244141C17.34 0.000244141 16 1.34024 16 3.00024Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_15_977">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.000244141)"
        />
      </clipPath>
    </defs>
  </g>
</template>
